import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  PARTNERSHIP,
  PARTNERSHIP_INVITATION_RESEND,
  PARTNERSHIP_LICENSE_SUMMARY_FINISHED
} from './partnershipActions';

const partnershipReducer = createResourceReducer(PARTNERSHIP, [], {
  [PARTNERSHIP_INVITATION_RESEND](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  },

  [PARTNERSHIP_LICENSE_SUMMARY_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      summary: action.payload.data.result
    }));
  }
});

export default partnershipReducer;
